<script>

import _ from 'lodash'

import { ChiRhos, ChiRhosNext } from '@paladin/core'

import {
  GroupApi,
  ApiPagedFilteredRequest,
  ApiEntityPagedRequest,
  ApiEntityRequest,
} from '@chirhos/chirhos-api'

import { bTreeView } from 'bootstrap-vue-treeview'
const ChiRhosNextApi = new ChiRhosNext().api();

let ChiRhosApi = new ChiRhos().api()
var groupApi = new GroupApi(ChiRhosApi)

export default {
  components: { bTreeView },
  props: {
    activeGroup: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      page: {
        subscriptions: [],
        subscriptionOptions: [],
      },
      subscriptionForm: {
        groupName: null,
        subscription: '00000000-0000-0000-0000-000000000000',
        original: '00000000-0000-0000-0000-000000000000',
      },
      address: {},
      addressOption: null,
      dirtyAddresses: false,
      addressOptions: [],
      parent: {
        id: '',
        type: null,
      },
      treeData: [
        {
          id: 1,
          name: 'Loading...',
          icon: 'fa fa-spinner spinner fa-spin',
        },
      ],
    }
  },
  computed: {
    selectedGroupSubscription: function() {
      var _activeGroup = this.activeGroup
      return this.page.subscriptions.data.find(function(obj) {
        if (obj.entity.subscriptionEntityId === _activeGroup.data.entity.subscriptionEntityId) {
          return obj
        }
      })
    },
  },
  watch: {
    $props: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted: function() {
    this.$nextTick(function() {

      this.init()

      ChiRhosNextApi.SubscriptionApi.list().then(
        response => {
          this.page.subscriptions = response
          this.page.subscriptionOptions = response.data.map((item) => {
            return {
              value: item.entity.entityId,
              text: `${item.entity.name}`,
            }
          })
        },
        error => {
          console.error(error);
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    })
  },
  created: function() {
  },
  methods: {
    init()
    {
      // todo
      this.parent.id = this.activeGroup.data.entity.belongsTo
      this.subscriptionForm.subscription = this.activeGroup.data.entity.subscriptionEntityId
      this.subscriptionForm.original = this.activeGroup.data.entity.subscriptionEntityId
      this.subscriptionForm.groupName = this.activeGroup.data.entity.name
      this.subscriptionForm.addresses = this.activeGroup.data.entity.addresses

      this.updateAddresses()

      if(this.parent.id !== '00000000-0000-0000-0000-000000000000')
      {
        let parent = this.parent

        groupApi
          .Get({
            request: new ApiEntityRequest(parent.id)
          })
          .then(
            (response) => {
              parent.type = response.data.entity.type

              groupApi
              .ListRootGroups({
                request: new ApiPagedFilteredRequest(null, 1, 100, this.showDeleted, { property: "entity.name", direction: "asc" }, null),
              })
              .then(
                (response) => {
                  this.treeData = response.data.map((item) => {
                    return {
                      id: item.entity.entityId,
                      parent: item.entity.belongsTo,
                      icon: item.entity.type === parent.type ? 'fa fa-check check' : 'fa fa-times times',
                      type: item.entity.type,
                      fullName: false,
                      children: [],
                      name: item.entity.name
                    }
                  })
                },
                (error) => {
                  console.error(error)
                  this.$toast(error, 'error')
                }
              )
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      }
      else this.parent.type = null
    },
    updateSubscriptionSubmit(evt) {
      evt.preventDefault()

      if(this.subscriptionForm.subscription !== this.subscriptionForm.original)
      {
        let _subscriptionUpdateRequest = {
          groupEntityId: this.activeGroup.data.entity.entityId,
          subscriptionEntityId: this.subscriptionForm.subscription,
        }

        ChiRhosNextApi.GroupApi.updateSubscription(_subscriptionUpdateRequest).then(
          () => {
            this.$toast('Subscription successfully changed', 'success')
          },
          error => {
            console.error(error);
            error.json().then(body => {
              this.$toast(body.Message, "error")
            })
          }
        )
      }

      if(this.subscriptionForm.groupName !== this.activeGroup.data.entity.name || this.dirtyAddresses || this.parent.id !== this.activeGroup.data.entity.belongsTo)
      {
        let group = this.activeGroup.data.entity

        group.name = this.subscriptionForm.groupName
        group.belongsTo = this.parent.id

        if(this.dirtyAddresses)
        {
          group.addresses = this.subscriptionForm.addresses
        }

        ChiRhosNextApi.GroupApi.post(group).then(
          (/* data */) => {
            this.$toast('Group successfully updated', 'success')
          },
          (error) => {
            console.error(error);
            error.json().then(body => {
              this.$toast(body.Message, "error")
            })
          }
        )
      }
    },
    updateAddresses()
    {
      this.addressOptions = []

      if(this.subscriptionForm.addresses)
      {
      this.addressOptions = this.subscriptionForm.addresses.map(function(item, index) {
        return {
          value: index,
          text: item.name
        }
      })
      }

      this.addressOptions.unshift({ value: null, text: '- new address -'})
    },
    loadAddress()
    {
      if(this.addressOption !== null)
      {
        this.address = _.clone(this.subscriptionForm.addresses[this.addressOption], true)
      }
      else
      {
        this.address = {}
      }
    },
    saveAddress()
    {
      this.dirtyAddresses = true

      if(!this.subscriptionForm.addresses) this.subscriptionForm.addresses = []

      if(this.addressOption !== null)
      {
        this.subscriptionForm.addresses[this.addressOption] = this.address
      }
      else
      {
        this.subscriptionForm.addresses.push(this.address)
      }

      this.updateAddresses()
    },
    saveAsAddress()
    {
      if(!this.subscriptionForm.addresses) this.subscriptionForm.addresses = []

      this.dirtyAddresses = true

      this.subscriptionForm.addresses.push(this.address)

      this.updateAddresses()
    },
    deleteAddress()
    {
      this.dirtyAddresses = true

      if(this.addressOption !== null)
      {
        this.subscriptionForm.addresses.splice(this.addressOption, 1)
      }

      this.updateAddresses()
    },
    async nodeSelect(node, isSelected) {
      if (isSelected) {

        // Get child groups for selected group
        var _groupChildrenPromise = groupApi.ListChildGroups({
          request: new ApiEntityPagedRequest(node.data.id, 1, 100, this.showDeleted, null, { property: "entity.name", direction:"asc" }, null),
        })

        let _groupDataResponse = await Promise.all([_groupChildrenPromise]).then(
          function(values) {
            return values
          }
        )

        if(node.data.type === this.parent.type)
        {
          this.parent.id = node.data.id
        }
        else
        {
          this.parent.id = this.activeGroup.data.entity.entityId
        }

        let parent = this.parent

        if (node.data['children'] === undefined) {
          node.$set(node.data, 'children', [])
        } else {
          node.data['children'] = []
        }
        _groupDataResponse[0].data.forEach((item) => {
          node.data.children.push({
            id: item.entity.entityId,
            parent: item.entity.belongsTo,
            name: item.entity.name,
            type: item.entity.type,
            children: [],
            icon: item.entity.type === parent.type ? 'fa fa-check check' : 'fa fa-times times',
          })
        })
        node.expanded = true
      }
    },
  },
}
</script>

<template src="./paladin-group-settings.html"></template>
